import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'castAny' })
export class CastAnyPipe implements PipeTransform {
  transform(value: any): any {
    return value;
  }
}
